var React = require('react');
var ChangeStepButtons = require('../ChangeStepButtons/changeStepButtons.jsx');
var CompleteYourProfile = require('./ReactDependencies/CompleteYourProfile.jsx');
var ContactInformation = require('./ReactDependencies/ContactInformation.jsx');
var memberTypeChecker = require('../../../../Scripts/React/MemberTypeChecker.jsx').step4;
var { $form } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

class Step3 extends React.Component {
    constructor(props) {
        super(props);

        this.bindFunctions();
    }

    componentDidMount() {
        if (this.props.appState.isMilitary) {
            this.props.loadApiData("militaryBranch");
            this.props.loadApiData("militaryPrefix");
        }

        if (this.props.appState.isGovernmentEmployee) {
            this.props.loadApiData("governmentSector");
        }

        this.props.loadApiData('countriesAndStates');
        this.props.loadApiData('ethnicity');
        this.props.loadApiData('race');
        this.props.loadApiData('gender');
    }

    bindFunctions() {
        this.goToStep = this.goToStep.bind(this);
        this.prevStepValid = this.prevStepValid.bind(this);
        this.nextStepValid = this.nextStepValid.bind(this);
        this.setDefaultPrimaryPracticeLocation = this.setDefaultPrimaryPracticeLocation.bind(this);
    }

    prevStepValid() {
        return this.props.appState.currentStep > 3 || this.props.appState.debugMode;
    }

    nextStepValid() {
        return this.props.appState.currentStep < 6 || this.props.appState.debugMode;
    }

    goToStep(event) {
        var nextStep = memberTypeChecker.skipStep4(this.props.appState.appType) ? 5 : 4;
        this.props.goToStep(event, nextStep, this.setDefaultPrimaryPracticeLocation);
    }

    setDefaultPrimaryPracticeLocation() {
        var primaryPracticeLocation;

        if (!this.props.stepState.primaryPracticeLocation) {
            if (this.props.appState.isMilitary) {
                primaryPracticeLocation = 'USSA';
            } else if (memberTypeChecker.stateOfPrimaryPracticeHide(this.props.appState.appType)) {
                primaryPracticeLocation = 'Other - International';
            } else if (this.props.appState.primaryPracticeLocation) {
                primaryPracticeLocation = this.props.appState.primaryPracticeLocation;
            } else if (this.props.getOtherStepData(2, 'primaryPracticeLocation')) {
                primaryPracticeLocation = this.props.getOtherStepData(2, 'primaryPracticeLocation');
            } else {
                primaryPracticeLocation = this.props.getOtherStepData(3, 'state');
            }

            this.props.updateStepState('primaryPracticeLocation', primaryPracticeLocation);
        }
    }

    render() {
        return <div className={"step-3-container"}>
            <$form onSubmit={this.goToStep} ref={c => { this.form = c }}>


                <div className={'row'}>
                    <div className={'col-md-8'}>
                        <CompleteYourProfile {...this.props} />
                        <ContactInformation {...this.props} />
                    </div>
                    <div className={'col-md-4'}>
                        {this.props.cartComponent}
                    </div>
                </div>


                <ChangeStepButtons
                    disableUI={this.props.appState.disableUI}
                    nextStepValid={this.nextStepValid}
                    prevStepValid={this.prevStepValid}
                    goPrevStep={this.props.goPrevStep}
                    currentStep={this.props.appState.currentStep} />
            </$form>
        </div>;
    }
}

module.exports = Step3;